import { useState } from 'react';
import { faqs } from '@/mocks/motionComics';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 md:gap-10">
          <div className="lg:col-span-2">
            <span className="text-xs font-medium tracking-widest text-primary-400">FAQ</span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">常见问题</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-300">
              关于韩国动态漫画的观看、更新与播放问题，这里都有答案。如果没有解决你的疑问，欢迎通过下方联系方式告诉我们。
            </p>
            <a
              href="#contact"
              className="mt-6 inline-flex whitespace-nowrap items-center gap-2 rounded-md border border-background-300/60 bg-background-100 px-5 py-2.5 text-sm text-foreground-200 transition-colors hover:border-primary-400 hover:text-primary-400"
            >
              还有疑问？联系我们
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="divide-y divide-background-300/50 rounded-lg border border-background-300/50 bg-background-100">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.question}>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                      aria-expanded={isOpen}
                    >
                      <h3 className="text-sm font-medium text-foreground-50 md:text-base">{f.question}</h3>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300/60 text-foreground-300 transition-transform duration-300 ${
                          isOpen ? 'rotate-45 border-primary-400 text-primary-400' : ''
                        }`}
                      >
                        <i className="ri-add-line" aria-hidden="true"></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-in-out ${
                        isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-4 pb-5 text-sm leading-7 text-foreground-300 md:px-5">{f.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}